export const THEME_COLORS = {
    GREEN: '#21ba45',
    RED: '#d22421'
}
